/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import BluebirdPromise from 'bluebird';
import _ from 'underscore';
// eslint-disable-next-line no-restricted-imports
import parseURL from 'url-parse';

import type { ActionSubjectIdType } from '@trello/atlassian-analytics';
import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { isEmbeddedInAtlassian, isTouch } from '@trello/browser';
import { renderComponent } from '@trello/component-wrapper';
import { setDynamicTokens } from '@trello/dynamic-tokens';
import { getBoardBackground } from '@trello/dynamic-tokens/dynamic-board-tokens';
import { assert } from '@trello/error-handling';
import { sendChunkLoadErrorEvent } from '@trello/error-reporting';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  getKey,
  Key,
  registerShortcutHandler,
  Scope,
  unregisterShortcutHandler,
} from '@trello/keybindings';
import { showLabelsState } from '@trello/labels';
import { getScreenFromUrl } from '@trello/marketing-screens';
import type { PIIString } from '@trello/privacy';
import ReactDOM from '@trello/react-dom-wrapper';
import { navigate } from '@trello/router/navigate';
import { TrelloStorage } from '@trello/storage';
import { getGlobalTheme, GlobalThemeObserver } from '@trello/theme';
import { importWithRetry } from '@trello/use-lazy-component';
import { workspaceNavigationState } from '@trello/workspace-navigation';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { errorPage } from 'app/scripts/controller/errorPage';
import {
  getCurrentBoardViewSection,
  showingBoardView,
  showingCalendar,
} from 'app/scripts/controller/getCurrentBoardView';
import { getQueryParamsToKeepOnBoardView } from 'app/scripts/controller/getQueryParamsToKeepOnBoardView';
import { setBoardLocation } from 'app/scripts/controller/setBoardLocation';
import { setTitleAndLocation } from 'app/scripts/controller/setTitleAndLocation';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { redoAction, undoAction } from 'app/scripts/lib/last-action';
import { Util } from 'app/scripts/lib/util';
import type { Board } from 'app/scripts/models/Board';
import type { Card } from 'app/scripts/models/Card';
import type { List } from 'app/scripts/models/List';
import type { Member } from 'app/scripts/models/Member';
import { LabelState } from 'app/scripts/view-models/LabelState';
import type { BoardSidebarView } from 'app/scripts/views/board-menu/BoardSidebarView';
import type { ButlerView } from 'app/scripts/views/butler/ButlerView';
import type { CalendarControllerView } from 'app/scripts/views/calendar/CalendarControllerView';
import type { CardView } from 'app/scripts/views/card/CardView';
import type { DirectoryView } from 'app/scripts/views/directory/DirectoryView';
import { pluginsChangedSignal } from 'app/scripts/views/internal/plugins/PluginsChangedSignal';
import { templates } from 'app/scripts/views/internal/templates';
import type { ViewOptions } from 'app/scripts/views/internal/View';
import { View } from 'app/scripts/views/internal/View';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { Layout } from 'app/scripts/views/lib/Layout';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListListView } from 'app/scripts/views/list/ListListView';
import type { ListView } from 'app/scripts/views/list/ListView';
import type { MapView } from 'app/scripts/views/map/MapView';
import {
  clickCloseDirectory,
  closeButler,
  closeCalendar,
  closeDetailView,
  closeDirectory,
  closeMap,
  closePowerUpView,
  dismissFeedback,
  isButlerViewActive,
  isShowingCalendar,
  navigateToBoard,
  navigateToBoardEvent,
  navigateToButler,
  navigateToButlerView,
  navigateToCalendar,
  navigateToCalendarEvent,
  navigateToDirectory,
  navigateToMap,
  reloadCustomFields,
  setButlerView,
  showButlerView,
  showCalendar,
  showDashboard,
  showDirectory,
  showMap,
  showPowerUpView,
  toggleButlerView,
  toggleCalendar,
  toggleDirectory,
} from 'app/scripts/views/plugin/PluginBoardView';
import type { PluginViewView } from 'app/scripts/views/plugin/PluginViewView';
import { BoardTemplate } from 'app/scripts/views/templates/BoardTemplate';
import { LazyAboutThisBoardModal as AboutThisBoardModal } from 'app/src/components/AboutThisBoardModal';
import { LazyBoardClosed } from 'app/src/components/BoardClosed';
import { BoardSidebarLoadingError } from 'app/src/components/BoardSidebarLoadingError';
import { LazyConfirmEmailModal as ConfirmEmailModal } from 'app/src/components/ConfirmEmailModal';
import { filteredCardsCountState } from 'app/src/components/FilterPopover/filteredCardsCountState';
import { JoinBoardModal } from 'app/src/components/JoinBoardModal';
import {
  LabelsPopoverState,
  LazyLabelsPopover,
} from 'app/src/components/LabelsPopover';
import { toQueryStringWithDecodedFilterParams } from 'app/src/components/ViewFilters/toQueryStringWithDecodedFilterParams';
import { viewFiltersContextSharedState } from 'app/src/components/ViewFilters/viewFiltersContextSharedState';
import { enableDragScroll } from 'app/src/enableDragScroll';
import { getMarketingScreenInfo } from 'app/src/getMarketingScreenInfo';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';
import { renderBoardBackground } from './BoardViewBackground';
import {
  _insertCardPosition,
  copyCardRequested,
  dblClickAddListMenu,
  moveCard,
  moveCardRequested,
  openCardComposerInFirstList,
  preventScrollSelection,
  scrollToCard,
} from './BoardViewCard';
import {
  clearFilters,
  closeAutomaticReports,
  closeSingleBoardView,
  initializeFilterCountMonitoring,
  navigateToAutomaticReports,
  removeReactBoardHeader,
  renderReactBoardHeader,
  showAutomaticReports,
  showCalendarView,
  showCleanUp,
  showTable,
  showTimeline,
} from './BoardViewHeader';
import { renderBoardWarnings } from './BoardViewLimit';
import {
  openListComposer,
  postListListRender,
  renderLists,
  scrollToList,
  sortCommit,
  viewForList,
} from './BoardViewList';
import { openAddMembers, showMemberProfile } from './BoardViewMember';
import { markRelatedNotificationsRead } from './BoardViewNotifications';
import { _delete, reopen } from './BoardViewOpenCloseDelete';
import { refreshOrganization, renderOrgChanges } from './BoardViewOrganization';
import { permChange, renderPermissionLevel } from './BoardViewPermission';
import {
  renderTeamOnboardingPupPopover,
  renderTeamOnboardingPupTooltip,
  unmountTeamOnboardingPupPopover,
  unmountTeamOnboardingPupTooltip,
} from './BoardViewTeamOnboardingPups';
import { isTemplate } from './BoardViewTemplate';
import { DisplayBoardError } from './displayBoardError';
import { renderInviteeOrientation } from './renderInviteeOrientation';

function showCardOnBoard(
  idCard: string,
  highlight: string | undefined,
  board: Board,
  replyToComment: string | undefined,
  loadCardData: (idCard: string) => BluebirdPromise<Card>,
) {
  return BluebirdPromise.try(function () {
    let card;
    if ((card = board.getCard(idCard)) != null) {
      // We're making the assumption here that if we can find the card, then we
      // don't need to call loadCardData.  If we don't have e.g.
      // the idBoard, idList or name then we know for sure that we've
      // violated that assumption.
      assert(
        card.get('idBoard') != null &&
          card.get('idList') != null &&
          card.get('name') != null,
        'Tried to display a card that was only partially loaded',
      );
      return card;
    } else {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      return loadCardData(idCard).tap(function (card) {
        if (card.get('idBoard') !== board.id) {
          BluebirdPromise.reject(
            DisplayBoardError.CardNotFoundOnThisBoard('', {
              idBoard: board.id,
            }),
          );
        }
      });
    }
  }).then((card) => {
    const cardRole = card.getCardRole();

    const cardBackRoot = document.getElementById('react-root-card-back');
    if (cardBackRoot) {
      ReactDOM.unmountComponentAtNode(cardBackRoot);
    }

    if (cardRole === 'board') {
      navigate(parseURL(card.get('name')).pathname, { trigger: true });
    } else if (cardRole === 'separator' || cardRole === 'link') {
      navigate(getBoardUrl(card.get('idBoard')), { trigger: true });
    } else {
      Controller.showCardDetail(card, { highlight, replyToComment });
    }
  });
}

interface BoardView {
  butlerView: ButlerView | null;
  calendarView: CalendarControllerView | null;
  calendarReturnCard: Card | null | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collectionSubview: <T extends new (...args: any) => any>(
    view: T,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    collection: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any,
  ) => InstanceType<T>;
  directoryView: DirectoryView | null;
  directoryReturnCard: Card | null | undefined;
  globalThemeObserver: GlobalThemeObserver;
  headerBranding?: () => void;
  ignoreMouseCardSelects: boolean;
  listListView: ListListView;
  mapCenterTo: {
    lat: string;
    long: string;
  } | null;
  mapReturnCard: Card | null | undefined;
  mapView: MapView | null;
  memberTypeMe: string;
  model: Board;
  pluginView: PluginViewView | null;
  refreshOrganizationDebounced: typeof refreshOrganization;
  reloadCustomFieldsDebounced: typeof reloadCustomFields;
  reloadDirectoryPlugins: boolean;
  renderBoardBackgroundDebounced: typeof renderBoardBackground;
  renderReactBoardHeaderDebounced: typeof renderReactBoardHeader;
  renderBoardWarningsDebounced: typeof renderBoardWarnings;
  renderDebounced: () => void;
  renderListsDebounced: typeof renderLists;
  renderPermissionLevelDebounced: typeof renderPermissionLevel;
  setDynamicTokensOnBoardViewDebounced: () => void;
  sidebarView: BoardSidebarView;
  sidebarViewPromise: Promise<{ BoardSidebarView: typeof BoardSidebarView }>;
  subscribe: (eventName: string, callback: () => void) => void;
  teamOnboardingPupPopoverDiv: HTMLDivElement | null;
  teamOnboardingPupTooltipDiv: HTMLDivElement | null;
  unmountBoardClosed: ReturnType<typeof renderComponent> | null;
  unmountConfirmEmailModal: ReturnType<typeof renderComponent> | null;
  unmountJoinBoardModal: ReturnType<typeof renderComponent> | null;
  unmountLabelsPopover: ReturnType<typeof renderComponent> | null;
  unmountLists: ReturnType<typeof renderComponent> | null;
  unsubscribeViewFiltersContext: ReturnType<
    typeof viewFiltersContextSharedState.subscribe
  >;
  _isFirstBoardEverLoaded(): boolean;
  _shouldCloseBoardMenu(): boolean;
  shouldCloseBoardMenu: boolean;
  _isGhostUsingInviteLink(): boolean;
  showSidebar(): void;
  hideSidebar(): void;
  setSidebarShow(): void;
  showSidebarOnOpen(): void;
  renderBoardWarnings(): void;
  renderLists(): void;
  _sidebarHideTimeout: number;
  zoom: number;
}

interface BoardViewOptions extends ViewOptions {
  settings?: {
    menu: 'closed' | 'filter' | 'activity';
    filter: string;
  } | null;
  headerBranding?: () => void;
}

class BoardView extends View<Board, BoardViewOptions> {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'board-wrapper';

    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Boa... Remove this comment to see the full error message
    this.prototype.displayName = 'BoardView';

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ sortcommit: string; 'keydown .js-board-nam... Remove this comment to see the full error message
      sortcommit: 'sortCommit',

      'click .js-close-calendar': 'toggleCalendar',
      'click .js-calendar': 'toggleCalendar',
      'click .js-disable-feedback': 'dismissFeedback',
      'click .js-close-dashboard': 'navigateToBoard',

      'click .js-dismiss-warning'(e: JQuery.TriggeredEvent) {
        TrelloStorage.set(
          // @ts-expect-error TS(2339): Property '$el' does not exist on type '() => { [ke... Remove this comment to see the full error message
          $(e.currentTarget, this.$el).attr('data-dismiss'),
          Date.now(),
        );
        // @ts-expect-error TS(2339): Property 'renderBoardWarnings' does not exist on t... Remove this comment to see the full error message
        return this.renderBoardWarnings();
      },

      'dblclick #board': 'dblClickAddListMenu',
      'click #board': 'blurInputsOnBoardClick',

      'click .js-reopen': 'reopen',
      'click .js-delete': 'delete',

      'click .js-clean-up': 'showCleanUp',

      'prevent-scroll-selection': 'preventScrollSelection',

      'click .js-close-directory': 'clickCloseDirectory',
    };
  }

  isTemplate() {
    return isTemplate.call(this);
  }

  _applySettings() {
    if (this.options.settings == null) {
      return;
    }

    const { menu, filter } = this.options.settings;

    switch (menu) {
      case 'closed':
        this.model.viewState.setShowSidebar(false);
        break;
      case 'filter':
      case 'activity':
        this.sidebarViewPromise.then(() => {
          this.setSidebarShow();
          return this.sidebarView.pushView(menu);
        });
        break;
      default:
    }

    if (filter) {
      return this.model.filter.fromQueryString(filter);
    }
  }

  permChange(newPerm: string) {
    return permChange.call(this, newPerm);
  }

  openListComposer() {
    return openListComposer.call(this);
  }

  openCardComposerInFirstList() {
    return openCardComposerInFirstList.call(this);
  }

  scrollToList(list: List) {
    return scrollToList.call(this, list);
  }

  viewForList(list: List) {
    return viewForList.call(this, list);
  }

  scrollToCard(card: Card) {
    return scrollToCard.call(this, card);
  }

  preventScrollSelection() {
    return preventScrollSelection.call(this);
  }

  markRelatedNotificationsRead() {
    return markRelatedNotificationsRead.call(this);
  }

  moveCard(direction: 'up' | 'down' | 'left' | 'right') {
    return moveCard.call(this, direction);
  }

  renderTeamOnboardingPupPopover() {
    return renderTeamOnboardingPupPopover.call(this);
  }

  renderTeamOnboardingPupTooltip() {
    return renderTeamOnboardingPupTooltip.call(this);
  }

  unmountTeamOnboardingPupPopover() {
    return unmountTeamOnboardingPupPopover.call(this);
  }

  unmountTeamOnboardingPupTooltip() {
    return unmountTeamOnboardingPupTooltip.call(this);
  }

  _shouldCloseBoardMenu() {
    // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
    const isNewBoard = new Date() - Util.idToDate(this.model.id) < 180000;

    // if a previous render of this board marked it as needing its menu closed,
    // keep it closed until the user opens it themselves
    return (
      this.shouldCloseBoardMenu ||
      // close the menu of the first board they ever load
      !Auth.me().isDismissed('close-menu-of-first-board') ||
      // close menu of first board ever created, which may not be the same as the
      // first board they ever load, because of invitations
      (isNewBoard && this.model.isFirstOwnedBoard())
    );
  }

  _isFirstBoardEverLoaded() {
    return (
      !Auth.me().isDismissed('close-menu-of-first-board') &&
      !this.model.isWelcomeBoard()
    );
  }

  _isGhostUsingInviteLink() {
    return Util.hasValidInviteTokenFor(this.model);
  }

  renderOpen() {
    this.showSidebarOnOpen();

    const data: {
      url: string;
      canJoin: boolean;
      canInviteMembers: boolean;
      confirmed: boolean;
    } = {
      url: getBoardUrl(this.model),
      canJoin: this.model.canJoin(),
      canInviteMembers: this.model.canInviteMembers(),
      confirmed: Auth.me().get('confirmed'),
    };
    for (const preference of Array.from(
      this.model.prefNames.concat(this.model.myPrefNames),
    )) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      data[`${preference}_${this.model.getPref(preference)}`] = true;
    }

    if (!isBoardCanvasModernizationEnabled()) {
      this.listListView.$el.detach();
    }

    this.$el.html(templates.fillFromModel(BoardTemplate, this.model));

    this.renderReactBoardHeader();
    this.renderBoardWarnings();
    this.renderBoardBackground();

    // On Backbone renders, running showBoardDetailView mounts the correct view
    // (table, maps, powerups, etc) from the URL, otherwise it will disappear.
    // @ts-expect-error TS(2339): Property 'boardPageSettings' does not exist on typ... Remove this comment to see the full error message
    const args = { ...this.options, ...Controller.boardPageSettings };
    this.showBoardDetailView(args);

    // this prevents the sidebar from animating in when first rendering.
    if (this.model.viewState.get('showSidebar') && !isEmbeddedInAtlassian()) {
      this.$el.addClass('is-show-menu');
    }

    this.sidebarViewPromise.then(() => {
      this.appendSubview(this.sidebarView, $('.js-fill-board-menu', this.$el));
      return this.renderSidebarState();
    });

    this.renderLists();
    renderInviteeOrientation({
      $el: this.$el,
      el: this.el,
      idBoard: this.model.id,
    });

    // @ts-expect-error TS(2345): Argument of type '{ title: any; }' is not assignab... Remove this comment to see the full error message
    setTitleAndLocation({ title: data.name });

    if (!isBoardCanvasModernizationEnabled()) {
      this.defer(() => {
        enableDragScroll(this.el.querySelector('#board') as HTMLElement, {
          fxIgnore(event) {
            // @ts-expect-error TS(2769): No overload matches this call.
            const boardEl = $(event.target).closest('#board');
            const isScrollbar = event.offsetY > boardEl.height() - 11;
            const isList =
              // @ts-expect-error TS(2769): No overload matches this call.
              $(event.target).closest('.js-list-content').length > 0;
            const isListComposer =
              // @ts-expect-error TS(2769): No overload matches this call.
              $(event.target).closest('.js-add-list').length > 0;
            return isScrollbar || isList || isListComposer;
          },
        });

        return DragSort.refreshListSortable();
      });
    }
  }

  showSidebarOnOpen() {
    // Orient visitors to public boards if About This Board is enabled
    const fromPrefOrNotLoggedIn =
      this.model.viewState.getShowSidebarFromPref() ||
      Auth.me().get('notLoggedIn');
    const hasDesc = !!this.model.get('desc');
    const isMember = this.model.isMember(Auth.me());

    if (
      this.model.isPublic() &&
      !isMember &&
      hasDesc &&
      fromPrefOrNotLoggedIn &&
      !isTouch()
    ) {
      return this.model.viewState.set('showSidebar', true);
    } else if (this._shouldCloseBoardMenu() || isTouch()) {
      this.model.viewState.set('showSidebar', false);
      if (this._isFirstBoardEverLoaded() && !this._isGhostUsingInviteLink()) {
        this.shouldCloseBoardMenu = true;
        if (Auth.isLoggedIn()) {
          return Auth.me().dismiss('close-menu-of-first-board');
        }
      }
    } else {
      return this.model.viewState.setShowSidebarFromPref();
    }
  }

  renderSidebarState() {
    if (this.model.viewState.get('showSidebar') && !isEmbeddedInAtlassian()) {
      this.showSidebar();
    } else {
      this.hideSidebar();
    }
  }

  toggleSidebar() {
    return this.model.viewState.setShowSidebar(
      !this.model.viewState.get('showSidebar'),
    );
  }

  setSidebarShow() {
    this.model.viewState.setShowSidebar(true);
    this.shouldCloseBoardMenu = false;
  }

  showSidebar() {
    // this hides team onboarding tooltip that shows after you dismiss
    // the popover, which we should just close when the sidebar opens
    this.unmountTeamOnboardingPupTooltip();

    // Hacky... the entire transition will be hidden if
    // there isn't a slight delay between un-hiding and
    // enabling the transition class.
    clearTimeout(this._sidebarHideTimeout);
    $('.js-fill-board-menu', this.$el).removeClass('hide');
    this.defer(() => {
      return this.$el.addClass('is-show-menu');
    });

    this.sidebarViewPromise.then(() => {
      return this.sidebarView.sendDrawerScreenEvent(
        this.sidebarView.topSidebarViewName(),
        'showSidebar',
      );
    });
  }

  hideSidebar() {
    this.$el.removeClass('is-show-menu');
    clearTimeout(this._sidebarHideTimeout);
    // Even though the is-show-menu class moves the menu out of view, we want
    // to also *actually* hide it, so the browser doesn't does something weird
    // when the user does something like Ctrl+F for text that appears in the
    // sidebar.
    //
    // We're delaying the hide because we're giving the CSS transition time to
    // complete.  We could try to trigger off of the transitionEnd event but
    // that can be problematic (if another transition starts before the first
    // one finishes or doesn't happen at all because there isn't actually a
    // change in the property being transitioned)
    //
    // The timeout value we're using here isn't meant to match the length of the
    // transition, but hopefully it's longer than whatever the transition is,
    // but not so short that someone could reasonably hide the menu and then
    // Ctrl+F for something that was on it
    // @ts-expect-error
    this._sidebarHideTimeout = this.setTimeout(() => {
      $('.js-fill-board-menu', this.$el).addClass('hide');
    }, 250);
  }

  renderOrgChanges() {
    return renderOrgChanges.call(this);
  }

  refreshOrganization() {
    return refreshOrganization.call(this);
  }

  reloadCustomFields() {
    return reloadCustomFields.call(this);
  }

  renderReactBoardHeader() {
    return renderReactBoardHeader.call(this);
  }

  removeReactBoardHeader() {
    return removeReactBoardHeader.call(this);
  }

  renderBoardWarnings() {
    return renderBoardWarnings.call(this);
  }

  renderBoardBackground(waitForImage?: boolean) {
    return renderBoardBackground.call(this, waitForImage);
  }

  renderPermissionLevel() {
    return renderPermissionLevel.call(this);
  }

  postListListRender() {
    return postListListRender.call(this);
  }

  renderLists() {
    return renderLists.call(this);
  }

  sortCommit(
    e: Parameters<typeof sortCommit>[0],
    ui: Parameters<typeof sortCommit>[1],
  ) {
    return sortCommit.call(this, e, ui);
  }

  openAddMembers(e: Parameters<typeof openAddMembers>[0]) {
    return openAddMembers.call(this, e);
  }

  toggleCalendar() {
    return toggleCalendar.call(this);
  }

  dismissFeedback() {
    return dismissFeedback.call(this);
  }

  navigateToCalendarEvent() {
    return navigateToCalendarEvent.call(this);
  }

  navigateToCalendar(returnCard?: Card) {
    return navigateToCalendar.call(this, returnCard);
  }

  navigateToBoardEvent() {
    return navigateToBoardEvent.call(this);
  }

  navigateToBoard() {
    return navigateToBoard.call(this);
  }

  isShowingCalendar() {
    return isShowingCalendar.call(this);
  }

  navigateToMap(
    centerTo: {
      lat: string;
      long: string;
    },
    returnCard: Card,
  ) {
    return navigateToMap.call(this, centerTo, returnCard);
  }

  isButlerViewActive() {
    return isButlerViewActive.call(this);
  }

  toggleButlerView() {
    return toggleButlerView.call(this);
  }

  showButlerView(options: object) {
    return showButlerView.call(this, options);
  }

  setButlerView(
    url: Parameters<typeof setButlerView>[0],
    taskId: Parameters<typeof setButlerView>[1],
    source: Parameters<typeof setButlerView>[2],
  ) {
    return setButlerView.call(this, url, taskId, source);
  }

  navigateToButler() {
    return navigateToButler.call(this);
  }

  navigateToButlerView(
    options: Parameters<typeof navigateToButlerView>[0],
    trigger: Parameters<typeof navigateToButlerView>[1],
  ) {
    return navigateToButlerView.call(this, options, trigger);
  }

  showMemberProfile(member: Parameters<typeof showMemberProfile>[0]) {
    return showMemberProfile.call(this, member);
  }

  showCalendar(date: Parameters<typeof showCalendar>[0]) {
    return showCalendar.call(this, date);
  }

  showMap(options: Parameters<typeof showMap>[0]) {
    return showMap.call(this, options);
  }

  showPowerUpView(options: Parameters<typeof showPowerUpView>[0]) {
    return showPowerUpView.call(this, options);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  closePowerUpView(navigateToBoard: Parameters<typeof closePowerUpView>[0]) {
    return closePowerUpView.call(this, navigateToBoard);
  }

  showDashboard() {
    return showDashboard.call(this);
  }

  closeDetailView() {
    return closeDetailView.call(this);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  closeCalendar(navigateToBoard?: Parameters<typeof closeCalendar>[0]) {
    return closeCalendar.call(this, navigateToBoard);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  closeMap(navigateToBoard?: Parameters<typeof closeMap>[0]) {
    return closeMap.call(this, navigateToBoard);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  closeButler(navigateToBoard?: Parameters<typeof closeButler>[0]) {
    return closeButler.call(this, navigateToBoard);
  }

  clickCloseDirectory() {
    return clickCloseDirectory.call(this);
  }

  toggleDirectory() {
    return toggleDirectory.call(this);
  }

  navigateToDirectory(returnCard?: Parameters<typeof navigateToDirectory>[0]) {
    return navigateToDirectory.call(this, returnCard);
  }

  showDirectory(
    section: Parameters<typeof showDirectory>[0],
    category: Parameters<typeof showDirectory>[1],
    idPlugin: Parameters<typeof showDirectory>[2],
    isEnabling: Parameters<typeof showDirectory>[3],
  ) {
    return showDirectory.call(this, section, category, idPlugin, isEnabling);
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  closeDirectory(navigateToBoard: Parameters<typeof closeDirectory>[0]) {
    return closeDirectory.call(this, navigateToBoard);
  }

  showTimeline() {
    return showTimeline.call(this);
  }

  showCalendarView() {
    return showCalendarView.call(this);
  }

  showTable() {
    return showTable.call(this);
  }

  closeSingleBoardView() {
    return closeSingleBoardView.call(this);
  }

  clearFilters(e: Parameters<typeof clearFilters>[0]) {
    return clearFilters.call(this, e);
  }

  dblClickAddListMenu(e: Parameters<typeof dblClickAddListMenu>[0]) {
    return dblClickAddListMenu.call(this, e);
  }

  reopen(e: Parameters<typeof reopen>[0]) {
    return reopen.call(this, e);
  }

  delete(e: Parameters<typeof _delete>[0]) {
    return _delete.call(this, e);
  }

  _insertCardPosition(
    idListDefault: Parameters<typeof _insertCardPosition>[0],
  ) {
    return _insertCardPosition.call(this, idListDefault);
  }

  moveCardRequested(
    listView: Parameters<typeof moveCardRequested>[0],
    options: Parameters<typeof moveCardRequested>[1],
  ) {
    return moveCardRequested.call(this, listView, options);
  }

  copyCardRequested(
    listView: Parameters<typeof copyCardRequested>[0],
    options: Parameters<typeof copyCardRequested>[1],
  ) {
    return copyCardRequested.call(this, listView, options);
  }

  showCleanUp(e: Parameters<typeof showCleanUp>[0]) {
    return showCleanUp.call(this, e);
  }

  navigateToAutomaticReports(
    reportType: Parameters<typeof navigateToAutomaticReports>[0],
  ) {
    return navigateToAutomaticReports.call(this, reportType);
  }

  showAutomaticReports(reportType: Parameters<typeof showAutomaticReports>[0]) {
    return showAutomaticReports.call(this, reportType);
  }

  closeAutomaticReports(boardId: Parameters<typeof closeAutomaticReports>[0]) {
    return closeAutomaticReports.call(this, boardId);
  }

  initializeFilterCountMonitoring() {
    return initializeFilterCountMonitoring.call(this);
  }

  constructor(options: BoardViewOptions) {
    super(...arguments);
    this.headerBranding = options.headerBranding;
    this.onShortcut = this.onShortcut.bind(this);
    this.renderConfirmEmailModal = this.renderConfirmEmailModal.bind(this);
    if (!isBoardCanvasModernizationEnabled()) {
      registerShortcutHandler(this.onShortcut, { scope: Scope.Board });
    }
  }

  initialize() {
    super.initialize(...arguments);

    this.sidebarViewPromise = importWithRetry(
      () =>
        import(
          /* webpackChunkName: "board-sidebar-view" */ 'app/scripts/views/board-menu/BoardSidebarView'
        ),
    );
    this.sidebarViewPromise
      .then(({ BoardSidebarView }) => {
        this.sidebarView = this.subview(BoardSidebarView, this.model, {
          boardView: this,
        });
      })
      .catch(function (error) {
        if (error.name === 'ChunkLoadError') {
          sendChunkLoadErrorEvent(error);
          const container = document.querySelector('.board-menu');
          if (container) {
            return renderComponent(<BoardSidebarLoadingError />, container);
          }
        } else {
          throw error;
        }
      });

    this.teamOnboardingPupPopoverDiv = null;
    this.teamOnboardingPupTooltipDiv = null;

    this.makeDebouncedMethods(
      'refreshOrganization',
      'reloadCustomFields',
      'render',
      'renderBoardBackground',
      'renderReactBoardHeader',
      'renderBoardWarnings',
      'renderLists',
      'renderPermissionLevel',
      'setDynamicTokensOnBoardView',
    );

    this.listenTo(this.model, {
      'change:closed deleting': this.renderDebounced,
      'change:idOrganization': () => {
        this.reloadDirectoryPlugins = true;
        this.refreshOrganizationDebounced();
        this.headerBranding?.();
      },
      'change:memberships': this.renderPermissionLevelDebounced,
      'change:limits': this.renderBoardWarningsDebounced,
      'change:myPrefs': () => {
        this.renderReactBoardHeaderDebounced();
      },
      'change:name': () => {
        this.renderReactBoardHeaderDebounced();
      },
      'change:powerUps': () => {
        this.renderReactBoardHeaderDebounced();
        if (!this.model.isMapPowerUpEnabled()) {
          this.closeMap();
        }
        if (!this.model.isPowerUpEnabled('calendar')) {
          this.closeCalendar();
        }
      },
      'change:prefs.cardCovers': this.renderListsDebounced,
      'change:prefs.permissionLevel': () => {
        this.renderListsDebounced();
        this.renderPermissionLevelDebounced();
        this.renderReactBoardHeaderDebounced();
      },
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness':
        () => {
          this.renderBoardBackgroundDebounced(true);
          this.renderReactBoardHeaderDebounced();
          this.setDynamicTokensOnBoardViewDebounced();
        },
      'change:prefs.isTemplate': this.renderReactBoardHeaderDebounced,
      'change:prefs.selfJoin': this.renderReactBoardHeaderDebounced,
      permChange: this.permChange,
      ownedChange: this.renderReactBoardHeaderDebounced,
      destroy: () => {
        errorPage({
          errorType: 'boardNotFound',
        });
      },
    });

    this.listenTo(this.model.memberList, {
      'change:status': this.renderReactBoardHeaderDebounced,
    });

    this.listenTo(this.model.boardPluginList, 'add reset', () => {
      this.renderReactBoardHeaderDebounced();
      this.reloadCustomFieldsDebounced();
    });

    this.subscribe(pluginsChangedSignal(this.model), () => {
      this.renderReactBoardHeaderDebounced();
      if (!this.model.isMapPowerUpEnabled()) {
        this.closeMap();
      }
      if (!this.model.isPowerUpEnabled('calendar')) {
        this.closeCalendar();
      }
    });

    this.listenTo(this.model.viewState, {
      'change:showSidebar': this.renderSidebarState,
    });

    this.memberTypeMe = this.model.getMemberType(Auth.me());

    this.refreshOrganization();

    filteredCardsCountState.setValue({ count: 0, isLoading: false });
    this.initializeFilterCountMonitoring();

    if (!isBoardCanvasModernizationEnabled()) {
      this.listenTo(this.model.filter, 'change', () => {
        this.renderFilteringStatus();
      });

      this.listListView = this.collectionSubview(
        ListListView,
        this.model.listList,
        {
          id: 'board',
          model: this.model,
          className: `u-fancy-scrollbar js-no-higher-edits`,
          resetCallback: () => this.postListListRender(),
        },
      );

      // Why are we listening to mousemove? Isn't mouseenter sufficient?
      //
      // 1. Hover your mouse over a card
      // 2. Hit an arrow key, moving the selected card, but not in a way that
      //    scrolls the page -- so the mouse is still hovering over the original
      //    card view.
      // 3. Move your mouse.
      //
      // If we were only listening to mouseenter, we'd never select the card,
      // because the mouse didn't re-enter it.
      this.listenTo(this.listListView, {
        mouseMoveListView: (listView: ListView) => {
          return this.model.viewState.selectList(listView.model);
        },
        mouseLeaveListView: (listView: ListView) => {
          return this.model.viewState.selectList(null);
        },
        mouseMoveCardView: (listView: ListView, cardView: CardView) => {
          if (this._ignoreMouseMove()) {
            return;
          }
          return this.model.viewState.selectCard(cardView.model);
        },
        mouseLeaveCardView: (listView: ListView, cardView: CardView) => {
          if (this._ignoreMouseMove()) {
            return;
          }
          return this.model.viewState.selectCard(null);
        },
        moveCard: this.moveCardRequested,
        copyCard: this.copyCardRequested,
      });
    }

    this._applySettings();
    this.markRelatedNotificationsRead();

    this.reloadDirectoryPlugins = false;

    // Rerender the board header when the global theme changes.
    // This is used to update the `setDynamicTokens` call.
    // When the board header is migrated to React, all of this will be handled
    // by the `useDynamicTokens` hook.
    this.globalThemeObserver = new GlobalThemeObserver(() =>
      // Optional only to protect from the very niche outside possibility that
      // we somehow trigger this event before `makeDebouncedMethods` resolves.
      this.setDynamicTokensOnBoardViewDebounced?.(),
    );

    const { colorMode, effectiveColorMode } = getGlobalTheme();

    // Analytics migration -- move this to controller to capture all URL changes
    const { url, referrerUrl, referrerScreenName } = getMarketingScreenInfo();

    Analytics.sendMarketingScreenEvent({
      url,
      referrerUrl,
      referrerScreenName,
      event: {
        source: 'boardScreen',
        name: 'boardScreenV2',
        attributes: {
          colorMode,
          effectiveColorMode,
          isColorBlindModeEnabled: Auth.me().get('prefs')?.colorBlind ?? false,
          isFirstTimeViewingBoard: Controller.isFirstTimeViewingBoard,
          isShowingSidebar: this.model.viewState.get('showSidebar'),
          isShowingWorkspaceNavigation: workspaceNavigationState.value.expanded,
          isTemplate: this.model.isTemplate(),
          labelsState: showLabelsState.value.showText
            ? 'expanded'
            : 'collapsed',
          screen: getScreenFromUrl(),
          viewerIsBoardCreator:
            this.model.get('idMemberCreator') === Auth.myId(),
          visibility: this.model.getPermLevel(),
        },
        containers: formatContainers({
          idBoard: this.model.id,
          idOrganization: this.model.getOrganization()?.id,
        }),
      },
    });

    this.unsubscribeViewFiltersContext =
      viewFiltersContextSharedState.subscribe(() => {
        this.model.filter.viewFiltersContext =
          viewFiltersContextSharedState.value;
      });
  }

  onShortcut = (
    event: Parameters<Parameters<typeof registerShortcutHandler>[0]>[0],
  ) => {
    const allowedViewsShortcuts = [Key.f, Key.q, Key.x];
    const key = getKey(event);

    if (showingBoardView() && !allowedViewsShortcuts.includes(key)) {
      return;
    }

    const editable = this.model.editable();
    const isLoggedIn = Auth.isLoggedIn();

    const sendShortcutEvent = (
      shortcutName: ActionSubjectIdType,
      {
        shortcutKey = key,
        toggleValue,
        isHoveringCard,
      }: {
        shortcutKey?: string;
        toggleValue?: 'show' | 'hide';
        isHoveringCard?: boolean;
      } = {},
    ) => {
      let source: 'boardScreen' | 'timelineViewScreen' | 'calendarViewScreen' =
        'boardScreen';

      if (getCurrentBoardViewSection() === 'timeline') {
        source = 'timelineViewScreen';
      }

      if (getCurrentBoardViewSection() === 'calendar-view') {
        source = 'calendarViewScreen';
      }

      Analytics.sendPressedShortcutEvent({
        shortcutName,
        source: source,
        keyValue: shortcutKey,
        containers: {
          board: { id: this.model.id },
          organization: { id: this.model.get('idOrganization') },
          enterprise: { id: this.model.get('idEnterprise') },
        },
        attributes: {
          toggleValue:
            toggleValue !== undefined ? toggleValue.toLowerCase() : undefined,
          isHoveringCard:
            isHoveringCard !== undefined ? isHoveringCard : undefined,
        },
      });
    };

    switch (key) {
      case Key.q:
        if (isLoggedIn) {
          const traceId = Analytics.startTask({
            taskName: 'edit-board/filter',
            source: 'boardScreen',
          });

          try {
            this.model.filter.toggleQuietMode();
            event.preventDefault();
            sendShortcutEvent('myCardsShortcut');

            Analytics.taskSucceeded({
              taskName: 'edit-board/filter',
              source: 'boardScreen',
              traceId,
            });
          } catch (error) {
            Analytics.taskFailed({
              taskName: 'edit-board/filter',
              source: 'boardScreen',
              traceId,
              error,
            });
          }
        }
        return;

      case Key.x: {
        const traceId = Analytics.startTask({
          taskName: 'remove-boardFilter',
          source: 'boardScreen',
        });

        try {
          this.model.filter.clear();
          event.preventDefault();
          sendShortcutEvent('clearAllFiltersShortcut');

          Analytics.taskSucceeded({
            taskName: 'remove-boardFilter',
            source: 'boardScreen',
            traceId,
          });
        } catch (error) {
          Analytics.taskFailed({
            taskName: 'remove-boardFilter',
            source: 'boardScreen',
            traceId,
            error,
          });
        }

        return;
      }

      case Key.ClosedBracket:
      case Key.w:
        this.toggleSidebar();
        event.preventDefault();
        sendShortcutEvent('toggleBoardMenuDrawerShortcut', {
          toggleValue: this.model.viewState.get('showSidebar')
            ? 'show'
            : 'hide',
        });
        return;

      case Key.SemiColon: {
        const wasShowingLabelText = LabelState.getShowText();
        LabelState.toggleText();
        event.preventDefault();
        const toggleValue = wasShowingLabelText ? 'hide' : 'show';
        sendShortcutEvent('toggleLabelTextShortcut', { toggleValue });
        return;
      }

      case Key.ArrowDown:
      case Key.j:
        this.moveCard('down');
        event.preventDefault();
        sendShortcutEvent('moveDownShortcut');
        return;

      case Key.ArrowUp:
      case Key.k:
        this.moveCard('up');
        event.preventDefault();
        sendShortcutEvent('moveUpShortcut');
        return;

      case Key.ArrowRight:
        this.moveCard('right');
        event.preventDefault();
        sendShortcutEvent('moveRightShortcut');
        return;

      case Key.ArrowLeft:
        this.moveCard('left');
        event.preventDefault();
        sendShortcutEvent('moveLeftShortcut');
        return;

      case Key.n:
        if (editable) {
          const list = this.model.viewState.getList();
          const card = this.model.viewState.getCard();

          if (list != null) {
            const index =
              card != null
                ? list.openCards().indexOf(card) + 1
                : list.openCards().length;

            this.model.composer.save({
              list,
              index,
              vis: true,
            });

            event.preventDefault();
            sendShortcutEvent('insertCardShortcut', {
              isHoveringCard: card ? true : false,
            });
          }
        }
        return;

      case Key.z:
      case Key.Z:
        if (editable) {
          event.preventDefault();
          // Check shiftKey > Key.Z for consistency in case of caps lock.
          if (event.shiftKey) {
            redoAction({ source: 'boardScreen', idBoard: this.model.id });
            sendShortcutEvent('redoActionShortcut', {
              shortcutKey: 'Shift+Z',
            });
          } else {
            undoAction({ source: 'boardScreen', idBoard: this.model.id });
            sendShortcutEvent('undoActionShortcut');
          }
        }
        return;

      case Key.Escape:
        if (editable) {
          if (DragSort.sorting) {
            DragSort.abort();
          } else if (
            !(Layout.isEditing() || PopOver.isVisible || Dialog.isVisible)
          ) {
            if (this.model.composer.get('vis')) {
              this.model.composer.save('vis', false);
            } else if (this.model.viewState.get('listComposerOpen')) {
              this.model.viewState.set('listComposerOpen', false);
            } else {
              this.sidebarViewPromise.then(() => this.sidebarView.popView());
            }
          }

          if (showingCalendar(this)) {
            $('.calendar-day.active').removeClass('active');
          }

          event.preventDefault();
        }
        return;

      default:
        return;
    }
  };

  renderClosed() {
    const org = this.model.getOrganization();
    const isAtOrOverLimit =
      org != null ? org.isAtOrOverFreeBoardLimit() : false;

    this.unmountBoardClosed = renderComponent(
      <LazyBoardClosed
        boardId={this.model.get('id')}
        isAtOrOverLimit={isAtOrOverLimit}
      />,
      this.el,
    );
    this.renderBoardBackground();
  }

  render() {
    if (this.model.get('closed')) {
      this.renderClosed();
    } else {
      this.unmountBoardClosed?.();
      this.renderOpen();
    }
    this.renderLabelsPopover();
    this.renderAboutThisBoardModal();
    this.setDynamicTokensOnBoardView();

    return this;
  }

  // Render the new Labels Popover in React.
  renderLabelsPopover() {
    const reactRoot = this.el.querySelector(
      '.js-board-labels-popover-container',
    );
    /**
     * This render function sometimes gets called in rapid succession,
     * too quickly to actually render the component, so check if the unmount
     * function has been defined before rendering again.
     */
    if (reactRoot && !this.unmountLabelsPopover) {
      this.unmountLabelsPopover = renderComponent(
        <LazyLabelsPopover
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          // Since this is rendered on app load, pass in a getter for a fresh
          // editable value to ensure that this is up-to-date when rendered.
          // eslint-disable-next-line react/jsx-no-bind
          isEditable={() => this.model.editable()}
        />,
        reactRoot,
      );
    }
  }

  renderAboutThisBoardModal() {
    const hasReadMePup = this.model.isPluginEnabled('5d6fd294c2588608fdbf2d33');
    if (
      this.model.get('idMemberCreator') !== Auth.myId() &&
      Auth.confirmed() &&
      Controller.isFirstTimeViewingBoard &&
      !!this.model.get('desc') &&
      !this.model.get('closed') &&
      (!this.model.isTemplate() ||
        (this.model.isTemplate() && this.model.isMember(Auth.me()))) &&
      !hasReadMePup &&
      !isEmbeddedInAtlassian()
    ) {
      Dialog.show({
        reactElement: (
          <AboutThisBoardModal
            idBoard={this.model.id}
            idOrg={this.model.get('idOrganization')}
            onClose={Dialog.hide}
            desc={this.model.get('desc')}
            descData={this.model.get('descData')}
          />
        ),
        maxWidth: 600,
        displayType: 'about-this-board-modal',
      });
    }
  }

  renderConfirmEmailModal({ inviterName }: { inviterName: PIIString }) {
    $('#content').append(
      '<div class="board-confirm-email-modal-container"></div>',
    );
    const reactRoot = document.querySelector(
      '.board-confirm-email-modal-container',
    );

    if (reactRoot && !this.unmountConfirmEmailModal) {
      this.unmountConfirmEmailModal = renderComponent(
        <ConfirmEmailModal
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          inviterName={inviterName}
          boardName={this.model.get('name')}
          email={Auth.me().get('email')}
          dateLastActivity={this.model.get('dateLastActivity')}
          desc={this.model.get('desc')}
          descData={this.model.get('descData')}
          boardOpenCardCount={this.model.openCards().length}
        />,
        reactRoot,
      );
    }
  }

  renderJoinBoardModal({
    ghost,
    inviterName,
  }: {
    ghost: Member;
    inviterName: PIIString;
  }) {
    $('#content').append('<div class="join-board-modal-container"></div>');
    const reactRoot = document.querySelector('.join-board-modal-container');

    const signupUrl =
      '/signup?' +
      new URLSearchParams({
        reauthenticate: String(true),
        returnUrl: `${location.pathname}?completedInviteSignup=1`,
        email: ghost?.get('email') || '',
        fullName: ghost?.get('fullName') || '',
      });

    if (reactRoot && !this.unmountJoinBoardModal) {
      this.unmountJoinBoardModal = renderComponent(
        <JoinBoardModal
          idBoard={this.model.id}
          idOrganization={this.model.get('idOrganization')}
          inviterName={inviterName}
          boardName={this.model.get('name')}
          signupUrl={signupUrl}
          desc={this.model.get('desc')}
          descData={this.model.get('descData')}
          dateLastActivity={this.model.get('dateLastActivity')}
          boardOpenCardCount={this.model.openCards().length}
        />,
        reactRoot,
      );
    }
  }

  renderFilteringStatus() {
    const isFiltering = this.model.filter.isFiltering();

    $('.js-num-cards', this.$el).toggleClass('hide', !isFiltering);
    $('#board', this.$el).toggleClass('filtering', isFiltering);

    // Don't pull in Board Filters and overwrite Query Params if on a Board View
    if (showingBoardView()) {
      return;
    }

    const filterQueryString = this.model.filter.toQueryString();
    const filterQueryParams = new URLSearchParams(filterQueryString);

    const currentQueryParams = new URLSearchParams(location.search);

    // Calling replaceState too many times on a large board render will break
    // the progressive rendering of lists on a board
    if (filterQueryParams.get('filter') !== currentQueryParams.get('filter')) {
      if (filterQueryParams.has('filter'))
        // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        currentQueryParams.set('filter', filterQueryParams.get('filter'));
      else currentQueryParams.delete('filter');
      // Hack: The URL api auto-encodes commas and colons, but we want to use
      // "invalid" urls with `,` and `:` characters in them.
      const queryString =
        toQueryStringWithDecodedFilterParams(currentQueryParams);
      const query = queryString.length ? `?${queryString}` : '';
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      history.replaceState(null, null, location.pathname + query);
    }
  }

  /**
   * Sets dynamic tokens on the .board-wrapper element.
   * At present, these tokens are used for coloring the board header buttons.
   */
  setDynamicTokensOnBoardView() {
    const {
      backgroundBrightness,
      backgroundColor,
      backgroundTopColor,
      isBackgroundImage,
      // @ts-expect-error
    } = getBoardBackground(this.model.get('prefs'));
    const { effectiveColorMode } = getGlobalTheme();

    setDynamicTokens({
      element: this.el,
      dynamicTokens: [
        'dynamic.button',
        'dynamic.star',
        'dynamic.text',
        'dynamic.background',
      ],
      background: {
        backgroundBrightness,
        backgroundColor: isBackgroundImage
          ? backgroundTopColor
          : backgroundColor,
        isBackgroundImage,
      },
      colorMode: effectiveColorMode,
    });
  }

  remove() {
    if (this.calendarView != null) {
      this.calendarView.remove();
    }
    unregisterShortcutHandler(this.onShortcut);
    this.unmountTeamOnboardingPupPopover();
    this.unmountTeamOnboardingPupTooltip();
    this.unmountBoardClosed?.();
    this.unmountLabelsPopover?.();
    this.unmountLists?.();
    this.unmountConfirmEmailModal?.();
    this.unmountJoinBoardModal?.();
    this.removeReactBoardHeader();
    this.globalThemeObserver.unsubscribe();
    this.unsubscribeViewFiltersContext();

    return super.remove(...arguments);
  }

  // Because we are using mouse event handlers that stop propagation on mousedown events
  // (enableDragScroll.ts and jquery.sortable), we need to handle blurring of inputs
  // and textareas ourselves.
  blurInputsOnBoardClick(e: JQuery.TriggeredEvent) {
    const $target = $(e.target);

    // Ignore clicks on inputs and textareas. Note that inputs here can also be submit buttons
    // that are 'programmatically' clicked by the DOM upon form submission (on enter keypress)
    const clickedInput = $target.is('input') || $target.is('textarea');
    if (clickedInput) {
      return e?.stopPropagation();
    } else {
      return $('input, textarea').blur();
    }
  }

  /**
   * Normally, we evaluate mouse move to determine which card is currently
   * "selected", which essentially means the card gets hover styling, and that
   * keyboard shortcuts apply to it. Under the following circumstances, we don't
   * want that to happen. This is critical for things like maintaining a card's
   * "selected" state when a popover is opened in the quick edit menu.
   */
  _ignoreMouseMove() {
    return (
      this.ignoreMouseCardSelects ||
      PopOver.isVisible ||
      DragSort.sorting ||
      LabelsPopoverState.value.isOpen
    );
  }

  showBoardDetailView(args: {
    idCard?: string;
    section?:
      | 'board'
      | 'butler'
      | 'calendar-view'
      | 'dashboard'
      | 'map'
      | 'power-up'
      | 'power-ups'
      | 'table'
      | 'timeline';
    highlight?: string;
    replyToComment?: string;
    loadCardData: () => BluebirdPromise<Card>;
    usernameBoardProfile?: string | null;
    powerUpViewKey?: string;
    directoryIdPowerUp?: string;
    directorySection?: string;
    directoryCategory?: string;
    directoryIsEnabling?: boolean;
    mapCenterTo: {
      lat: string;
      long: string;
    };
    zoom: number;
    openListComposer?: boolean;
    openCardComposerInFirstList?: boolean;
    referrerUsername?: string;
    reportType?: string;
    calendarDate?: string;
    butlerTab?: string;
    butlerCmdEdit?: string;
    butlerCmdLog?: string;
    butlerNewCommand?: string;
    butlerUsage?: string;
    butlerAccount?: string;
    butlerNewIcon?: string;
    butlerNewLabel?: string;
    taskId?: string;
    source?: string;
  }) {
    return BluebirdPromise.try(() => {
      let date, idCard, member;
      const board = this.model;

      if ((idCard = args.idCard) != null) {
        showCardOnBoard.call(
          this,
          idCard,
          args.highlight,
          board,
          args.replyToComment,
          args.loadCardData,
        );
      } else if (
        args.usernameBoardProfile &&
        (member = board.modelCache.findOne(
          'Member',
          'username',
          args.usernameBoardProfile,
        )) != null
      ) {
        this.showMemberProfile(member);
      } else if (
        typeof args.section === 'string' &&
        ['power-up', 'power-ups'].includes(args.section)
      ) {
        const powerUpViewsEnabled = featureFlagClient.get(
          'ecosystem.power-up-views',
          false,
        );
        if (args.powerUpViewKey && powerUpViewsEnabled) {
          this.showPowerUpView({
            idPlugin: args.directoryIdPowerUp,
            viewKey: args.powerUpViewKey,
          });
        } else if (board.editable()) {
          this.showDirectory(
            args.directorySection,
            args.directoryCategory,
            args.directoryIdPowerUp,
            args.directoryIsEnabling,
          );
        } else {
          setBoardLocation(board.id);
        }
      } else if (args.section === 'map') {
        if (!board.isMapPowerUpEnabled()) {
          const boardUrl = getBoardUrl(board.id);
          navigate(boardUrl, { trigger: true });
        } else {
          this.showMap({
            mapCenterTo: args.mapCenterTo,
            zoom: args.zoom,
          });
        }
      } else if (args.section === 'dashboard') {
        this.showDashboard();
      } else if ((date = args.calendarDate) != null) {
        this.showCalendar(date);
      } else if (args.section === 'butler' && args.reportType) {
        this.showAutomaticReports(args.reportType);
      } else if (args.section === 'butler') {
        this.showButlerView({
          butlerTab: args.butlerTab,
          butlerCmdEdit: args.butlerCmdEdit,
          butlerCmdLog: args.butlerCmdLog,
          newCommand: args.butlerNewCommand,
          butlerUsage: args.butlerUsage,
          butlerAccount: args.butlerAccount,
          newIcon: args.butlerNewIcon,
          newLabel: args.butlerNewLabel,
          taskId: args.taskId,
          source: args.source,
        });
      } else if (args.section === 'table') {
        this.showTable();
      } else if (args.section === 'timeline') {
        this.showTimeline();
      } else if (args.section === 'calendar-view') {
        this.showCalendarView();
      } else {
        if (args.openListComposer) {
          this.openListComposer();
        }
        if (args.openCardComposerInFirstList) {
          // Deferred to ensure "Add a card" button below composer is hidden properly
          _.defer(() => this.openCardComposerInFirstList());
        }
        const extra = args.referrerUsername
          ? [args.referrerUsername, 'recommend']
          : undefined;
        const search = getQueryParamsToKeepOnBoardView();
        setBoardLocation(board.id, args.section, extra, { search });
      }

      return this;
    });
  }
}

BoardView.initClass();
export { BoardView };
